import type { AuthenticationAccessRight } from "src/authentication/objects/AuthenticationToken";

export default class SubscriberExportsAccessRight {
  public static VIEW_EXPORT_SUBSCRIBERS_LIST: AuthenticationAccessRight = ({ menuDisplayLevel }) =>  menuDisplayLevel <= 2 || menuDisplayLevel >= 4;
}
